<template lang="pug">
div
    .text-muted(v-if="totalFacts === 0") No fact data present
    .mb-4(v-if="regularFacts.length > 0")
        component(:is="headingTag" class="mb-2") Directly specified: {{regularFacts.length}}
        table.table.table-sm.table-striped
            thead
                tr
                    th(scope="col") #
                    th(scope="col") Age Range
                    th(scope="col") Sex
                    th(scope="col") Material
                    th(scope="col") Diagnosis
                    th(scope="col") #Donors
                    th(scope="col") #Samples
            tbody
                tr(v-for="(fact, index) in displayRegularFacts" :key="fact.id || `regular-${index}`")
                    td {{ index + 1 }}
                    td {{ fact.age_range }}
                    td {{ fact.sex }}
                    td {{ fact.sample_type }}
                    td {{ fact.disease }}
                    td {{ fact.number_of_donors }}
                    td {{ fact.number_of_samples }}
    .mb-2(v-if="derivedFacts.length > 0")
        component(:is="headingTag" class="mb-2") Derived from subcollections: {{derivedFacts.length}}
        table.table.table-sm.table-striped
            thead
                tr
                    th(scope="col") #
                    th(scope="col") Age Range
                    th(scope="col") Sex
                    th(scope="col") Material
                    th(scope="col") Diagnosis
                    th(scope="col") #Donors
                    th(scope="col") #Samples
            tbody
                tr(v-for="(fact, index) in displayDerivedFacts" :key="fact.id || `derived-${index}`")
                    td {{ index + 1 }}
                    td {{ fact.age_range }}
                    td {{ fact.sex }}
                    td {{ fact.sample_type }}
                    td {{ fact.disease }}
                    td {{ fact.number_of_donors }}
                    td {{ fact.number_of_samples }}
</template>

<script>
export default {
  props: {
    regularFacts: {
      type: Array,
      default: () => []
    },
    derivedFacts: {
      type: Array,
      default: () => []
    },
    headingTag: {
      type: String,
      default: "h6"
    }
  },
  computed: {
    totalFacts() {
      return this.regularFacts.length + this.derivedFacts.length;
    },
    displayRegularFacts() {
      return this.normalizeFacts(this.regularFacts);
    },
    displayDerivedFacts() {
      return this.normalizeFacts(this.derivedFacts);
    }
  },
  methods: {
    normalizeFacts(facts) {
      return (facts || []).map(fact => {
        const normalizedFact = {...fact};
        if (typeof normalizedFact.disease === "string") {
          const parts = normalizedFact.disease.split(":");
          normalizedFact.disease = parts[parts.length - 1];
        }
        return normalizedFact;
      });
    }
  }
}
</script>
